import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@core/auth/useAuth'
import { caminhoNoWorkspace } from './notificacoesRegras'

/**
 * `/~/...`: a ligação das notificações para quem vê um recurso a partir
 * de outro workspace (partilha nominal, convidado). O `~` é o workspace
 * da sessão de quem abre: segue-se para lá, com o resto do caminho. Sem
 * sessão, vai para a entrada.
 */
export default function NoMeuWorkspace() {
  const { mode, workspace } = useAuth()
  const { pathname, search } = useLocation()
  if (mode !== 'cloud' || !workspace) return <Navigate to="/login" replace />
  return <Navigate to={caminhoNoWorkspace(pathname, search, workspace.slug)} replace />
}
